
export const bigQueryTableColumns = [
    {
        title: 'Tracking id',
        dataIndex: 'tracking_id',
        key: 'tracking_id',
        sorter: (a, b) => a?.tracking_id?.localeCompare(b?.tracking_id),
    },
    {
        title: 'Event',
        dataIndex: 'event',
        key: 'event',
        sorter: (a, b) => a?.event?.localeCompare(b?.event),
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        sorter: (a, b) => a?.date?.value?.localeCompare(b?.date?.value),
    },
    {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        sorter: (a, b) => a?.location?.localeCompare(b?.location),
    },
    {
        title: 'User Agent',
        dataIndex: 'user_agent',
        key: 'user_agent',
        sorter: (a, b) => a?.user_agent?.localeCompare(b?.user_agent),
    },
    {
        title: 'IP',
        dataIndex: 'ip',
        key: 'ip',
        sorter: (a, b) => a?.ip?.localeCompare(b?.ip),
    },
    {
        title: 'Utm Source',
        dataIndex: 'utm_source',
        key: 'utm_source',
        sorter: (a, b) => a?.utm_source?.localeCompare(b?.utm_source),
    },
    {
        title: 'Utm Medium',
        dataIndex: 'utm_medium',
        key: 'utm_medium',
        sorter: (a, b) => a?.utm_medium?.localeCompare(b?.utm_medium),
    },
    {
        title: 'Utm Campaign',
        dataIndex: 'utm_campaign',
        key: 'utm_campaign',
        sorter: (a, b) => a?.utm_campaign?.localeCompare(b?.utm_campaign),
    },
    {
        title: 'Utm Content',
        dataIndex: 'utm_content',
        key: 'utm_content',
        sorter: (a, b) => a?.utm_content?.localeCompare(b?.utm_content),
    },
    {
        title: 'Utm Term',
        dataIndex: 'utm_term',
        key: 'utm_term',
        sorter: (a, b) => a?.utm_term?.localeCompare(b?.utm_term),
    },
    {
        title: 'Client Fingerprint',
        dataIndex: 'client_fingerprint',
        key: 'client_fingerprint',
        sorter: (a, b) => a?.client_fingerprint?.localeCompare(b?.client_fingerprint),
    },
    {
        title: 'Server Fingerprint',
        dataIndex: 'server_fingerprint',
        key: 'server_fingerprint',
        sorter: (a, b) => a?.server_fingerprint?.localeCompare(b?.server_fingerprint),
    },
    {
        title: 'Session',
        dataIndex: 'session',
        key: 'session',
        sorter: (a, b) => a?.session?.localeCompare(b?.session),
    },
    {
        title: 'Data',
        dataIndex: 'data',
        key: 'data',
        sorter: (a, b) => a?.data?.localeCompare(b?.data),
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        sorter: (a, b) => a?.price?.localeCompare(b?.price),
    },
    {
        title: 'Host',
        dataIndex: 'host',
        key: 'host',
        sorter: (a, b) => a?.host?.localeCompare(b?.host),
    },
    {
        title: 'Parent Session',
        dataIndex: 'parent_session',
        key: 'parent_session',
        sorter: (a, b) => a?.parent_session?.localeCompare(b?.parent_session),
    },
    {
        title: 'Order Id',
        dataIndex: 'order_id',
        key: 'order_id',
        sorter: (a, b) => a?.order_id?.localeCompare(b?.order_id),
    }
]